import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { WifiOff } from "lucide-react";
import { api } from "@/lib/api";

const STATUS = { reconnecting: "menyambung ulang…", logged_out: "keluar — perlu scan QR ulang", disconnected: "terputus", error: "gagal tersambung", qr: "menunggu scan QR" };

export const WhatsAppHealthBanner = () => {
  const [down, setDown] = useState([]);
  useEffect(() => {
    const load = () => api.get("/whatsapp/device/health").then((r) => setDown(r.data.down || [])).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  if (!down.length) return null;
  return (
    <div className="mb-4 rounded-lg border border-red-300 bg-red-50 dark:bg-red-950/40 dark:border-red-800 px-4 py-3 text-sm text-red-900 dark:text-red-200 flex flex-wrap items-center gap-2" data-testid="wa-health-banner">
      <WifiOff className="h-4 w-4 shrink-0" />
      <span className="font-semibold">WhatsApp tidak terhubung:</span>
      <span>{down.map((d) => `${d.label}${d.phone ? ` (+${d.phone})` : ""} — ${STATUS[d.status] || d.status}`).join(" · ")}</span>
      <span className="text-xs opacity-80">Pesan masuk ke nomor ini tidak tercatat sampai tersambung lagi.</span>
      <Link to="/master?tab=whatsapp" className="ml-auto underline font-medium" data-testid="wa-health-banner-link">Buka pengaturan WhatsApp</Link>
    </div>
  );
};
